/**
 * URLs que vienen de fuera: del snippet que pega el cliente o de la presentación del servidor.
 */

/**
 * Valida una URL absoluta `https`. Devuelve `null` con cualquier otra cosa, también con `http:`,
 * `javascript:` o `data:`: quien llama decide qué hacer con la ausencia. Solo `https` porque es lo
 * único que admite la CSP del panel (`img-src`), y la burbuja y la cabecera tienen que coincidir.
 */
export function normalizeImageUrl(value: unknown): string | null {
  if (typeof value !== 'string' || !value.trim()) return null;

  try {
    const url = new URL(value.trim());

    return url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}
